import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <IndexSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <FaqSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}